import { LoginForm, LoginFormContainer } from '@workwave-tidal/core/login-ui'
import { Logo } from '@user/components/TopToolbar/Logo'
import React from 'react'
import { useActions } from '@user/components/Login/LoginSSO/hooks/useActions'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Typography from '@mui/material/Typography'
import { getCookie } from '@sales-center/common'

export const LoginSSOContent = () => {
  const { checkWWMUserEmail, error, errorTitle } = useActions()

  return (
    <LoginFormContainer
      logo={
        <Logo colorful={true} style={{ width: '361px', height: '170px' }} />
      }
      form={
        <>
          {error && (
            <Alert severity="error" sx={{ mb: '16px' }}>
              <AlertTitle sx={{ fontSize: '16px' }}>{errorTitle}</AlertTitle>

              <Typography variant="body2">{error}</Typography>
            </Alert>
          )}

          <LoginForm
            onLogin={checkWWMUserEmail}
            texts={{
              fields: {
                username: {
                  label: 'Email',
                  required: 'Required',
                },
              },
              login: {
                label: 'Continue',
              },
            }}
            initialValues={{
              username: getCookie('rememberMe'),
              rememberMe: Boolean(getCookie('rememberMe')),
            }}
            fieldProps={{
              password: {
                hidden: true,
                required: false,
                shouldValidateWhenRequired: false,
              },
              rememberMe: {
                formControlLabelProps: {
                  sx: {
                    margin: 0,
                  },
                },
              },
            }}
          />
        </>
      }
    />
  )
}
